export default __webpack_public_path__ + "static/media/Poupon.4279c75f.jpg";